(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homeward-setup-basket"] && !Shopify.designMode) return;
  try {
    if (!window.homewardSetupBasketInstalled) {
  window.homewardSetupBasketInstalled = true;
  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-hss-basket]');
    if (!form) return;
    const selectors = Array.from(form.querySelectorAll('[data-hss-item]'));
    if (selectors.some((select) => !select.value)) return;
    const total = selectors.reduce((sum, select) => sum + Number(select.selectedOptions[0].dataset.price) * Number(select.dataset.quantity), 0);
    form.querySelector('[data-hss-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: form.dataset.currency || 'GBP' }).format(total / 100);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-hss-basket]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const selectors = Array.from(form.querySelectorAll('[data-hss-item]'));
    const items = selectors.map((select) => ({ id: Number(select.value), quantity: Number(select.dataset.quantity) }));
    if (!items.length || items.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isInteger(item.quantity) || item.quantity <= 0)) return;
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-hss-error]');
    const review = form.querySelector('[data-hss-review]');
    const label = button.textContent;
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.textContent = form.dataset.loading;
    selectors.forEach((select) => { select.disabled = true; });
    error.hidden = true;
    review.hidden = true;
    try {
      const response = await fetch(form.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || form.dataset.error);
      window.location.assign(form.dataset.cartUrl);
    } catch (failure) {
      error.textContent = form.dataset.error;
      error.hidden = false;
      review.hidden = false;
      form.dataset.busy = 'false';
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = label;
      selectors.forEach((select) => { select.disabled = false; });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
